"use client"

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { useToast } from "@/components/ui/use-toast"
import { CheckCircle2, XCircle, AlertCircle, Info } from "lucide-react"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        // Determine icon based on variant or title content
        let icon = null
        if (variant === "destructive" || title?.toString().includes("❌")) {
          icon = <XCircle className="h-5 w-5 text-destructive" />
        } else if (title?.toString().includes("✅")) {
          icon = <CheckCircle2 className="h-5 w-5 text-green-600" />
        } else if (title?.toString().includes("ℹ️")) {
          icon = <Info className="h-5 w-5 text-blue-600" />
        } else if (title?.toString().includes("🔄") || title?.toString().includes("📤")) {
          icon = <AlertCircle className="h-5 w-5 text-yellow-600" />
        }
        
        return (
          <Toast key={id} {...props} variant={variant}>
            <div className="flex gap-3">
              {icon && <div className="flex-shrink-0">{icon}</div>}
              <div className="grid gap-1 flex-1">
                {title && (
                  <ToastTitle>
                    {/* Remove emoji from title if icon is shown */}
                    {icon
                      ? title
                          .toString()
                          .replace(/✅|❌|ℹ️|🔄|📤/g, '')
                          .trim()
                      : title}
                  </ToastTitle>
                )}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
